import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { SetupContext } from 'src/consumer/context/SetupContext'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { getDataWithoutParams, getFeatureItemBySlug } from 'src/consumer/services/featureServices'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { LoadingSpinner } from '../Loaders'
import PublicAppHeader from '../PublicAppHeader'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'
import {
  InfoAndSingleActionComponentVarOne,
  RelatedAppFeaturesHeading,
} from '../ListingPageComponentsAndHelpers/ListingPageComponents'
import FaqSection from '../PrewallAndPaywall/FaqSection'
import { FAQ_CATEGORIES } from 'src/consumer/constants'
import { EventListingUI } from '../EventListing'
import { getDisplayEventTypesOfMentor } from '../Professionals List Page'
import { PublicAppFooter } from '../PublicAppFooter'
import { FAQ_LAYOUTS } from '../PrewallAndPaywall/faqComponents/utils'

export default function MentorLandingPage() {
  const navigate = useNavigate()
  const { mentorSlug, mentorId } = useParams()
  const { profileData } = useContext(ProfileContext)
  const { setupData } = useContext(SetupContext)
  const [mentorData, setMentorData] = useState()
  const [dataLoading, setDataLoading] = useState(false)
  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')
  const [plansData, setPlansData] = useState()
  const [selectedEventId, setSelectedEventId] = useState()
  const [displayEventTypes, setDisplayEventTypes] = useState([])

  async function pageSetup() {
    setDataLoading(true)
    let response
    if (mentorSlug) {
      response = await getFeatureItemBySlug('mentor', mentorSlug, true)
    } else {
      response = await getFeatureItemBySlug('mentor', mentorId, false)
    }
    if (
      response?.status === 200 &&
      response?.data &&
      Object.keys(response?.data)?.length !== 0 &&
      response?.data?.data?.mentor
    ) {
      setMentorData(response?.data?.data?.mentor)
      setDataLoading(false)
    } else {
      navigate('/404')
    }
  }

  async function getAndSetPlansData() {
    const response = await getDataWithoutParams('/api/subscription-plan/1on1')
    if (response?.status === 200 && response?.data?.length > 0) {
      setPlansData(response?.data)
    }
  }

  async function setDisplayEventTypesAndSelectedEvent() {
    if (mentorData) {
      const displayEventTypes = getDisplayEventTypesOfMentor(mentorData)?.sort((a, b) => {
        if (a?.free) {
          return -1
        } else {
          return 0
        }
      })
      setDisplayEventTypes(displayEventTypes)
      setSelectedEventId(displayEventTypes?.[0]?.uid)
    }
  }

  useEffect(() => {
    pageSetup()
    getAndSetPlansData()
  }, [])

  useEffect(() => {
    setDisplayEventTypesAndSelectedEvent()
  }, [mentorData])

  function handleStartLandingPage() {
    return null
  }

  return (
    <>
      {mentorData && (
        <SEOComponent
          title={mentorData?.name ? `${mentorData?.name} | AUMHUM` : 'AUMHUM'}
          description={`Explore courses, make bookings with ${mentorData?.name}`}
          image={mentorData && getImageLink(mentorData?.coverIcon, mentorData?.coverImage)}
        />
      )}
      {dataLoading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <>
          <PublicAppHeader
            loginFunction={() => {
              setTypeOfClubbedAuthModal('login')
              setShowClubbedAuthModal(true)
            }}
            registerFunction={() => {
              setTypeOfClubbedAuthModal('signup')
              setShowClubbedAuthModal(true)
            }}
            config={{ showLinks: false }}
            propUserProfileData={profileData}
          />
          <ClubbedAuthModal
            open={showClubbedAuthModal}
            onClose={() => {
              setShowClubbedAuthModal(false)
            }}
            loginVariant={typeOfClubbedAuthModal === 'login'}
          />
          <InfoAndSingleActionComponentVarOne
            headline={mentorData?.name}
            description={mentorData?.shortDesc}
            image={getImageLink(mentorData?.blogBanner, mentorData?.profilePicId)}
          />
          <RelatedAppFeaturesHeading data={'Book a 1 on 1 session'} />
          <EventListingUI
            professionalData={mentorData}
            displayEventTypes={displayEventTypes}
            plansData={plansData}
            selectedEventId={selectedEventId}
            setSelectedEventId={setSelectedEventId}
          />
          <FaqSection
            categoryIds={[FAQ_CATEGORIES.therapist_booking_page_faqs]}
            layoutType={FAQ_LAYOUTS.TWO_COLUMN_SIDEBAR}
          />
          <PublicAppFooter />
        </>
      )}
    </>
  )
}
